import { Skeleton } from 'antd';

import styles from './styles.module.scss';

const ChartSkeleton = () => (
  <div
    className={styles['chart-wrapper']}
    aria-live="polite"
    data-testid="chart-skeleton"
  >
    <Skeleton active paragraph={{ rows: 4 }} title={false} />
    <Skeleton active paragraph={{ rows: 1, width: '40%' }} title={false} />
  </div>
);

export default ChartSkeleton;
